import React, { useState } from "react";
import "./Banner.css";
import me3Removebg from "../../images/me3Removebg.png";
import { Col, Container, Image, Row } from "react-bootstrap";
import Typewriter from "typewriter-effect";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";

const Banner = () => {
  const [state] = useState({
    titleOne: "Hi,",
    titleTwo: "I'm",
    titleThree: "Zahidul Islam",
  });
  return (
    <Container className="banner-block" fluid>
      <Row xs={12} sm={12} md={2} lg={2} xl={2}>
        <Col>
          <div id="home" className="content-conatiner">
            <h1 className="text">
              <span className="titleOne">{state.titleOne}</span>
              <span className="titleTwo">{state.titleTwo}</span>
              <span className="titleThree">{state.titleThree}</span>
            </h1>
            <div style={{ color: "white", fontSize: "25px" }}>
              <Typewriter
                options={{
                  autoStart: true,
                  loop: true,
                  delay: "40ms",
                  strings: [
                    "I'm a Jr. Software Engineer...",
                    "I'm a MERN Develoepr...",
                    "I'm a Frontend Developer...",
                  ],
                }}
              />
            </div>
          </div>
          <div className="banner-icon-block  d-flex justify-content-start align-items-center  flex-wrap">
            <span className="banner-icon-container">
              {" "}
              <a href="https://www.facebook.com/profile.php?id=100042487011960">
                <li>
                  <FaFacebook className="banner-icon" />
                </li>
              </a>
            </span>
            <span className="banner-icon-container">
              <a href="https://www.instagram.com/z.islam144/">
                <li>
                  <FaInstagram className="banner-icon" />
                </li>
              </a>
            </span>

            <span className="banner-icon-container">
              <a href="https://www.linkedin.com/in/zahidul-islam-5432b5189/">
                <li>
                  <FaLinkedinIn className="banner-icon" />
                </li>
              </a>
            </span>
            <span className="banner-icon-container">
              <a href="https://github.com/zahidul-islam-144">
                <li>
                  <FaGithub className="banner-icon" />
                </li>
              </a>
            </span>
          </div>
        </Col>
        <Col className="img-col">
          <div className="image-block">
            <Image src={me3Removebg} fluid className="image" />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Banner;
